import { useEffect } from 'react';

const useAutomaticRetry = (enabled, retry, delay = 5000) => {
  useEffect(() => {
    if (!enabled) return undefined;

    let timerId = window.setTimeout(retry, delay);
    const retryWhenOnline = () => {
      window.clearTimeout(timerId);
      retry();
    };

    window.addEventListener('online', retryWhenOnline);

    return () => {
      window.clearTimeout(timerId);
      window.removeEventListener('online', retryWhenOnline);
    };
  }, [enabled, retry, delay]);
};

export default useAutomaticRetry;
